import React from "react";
import { Accordion, Card } from "react-bootstrap";
import "./accordion.css";

/**
 * AccordionComponent
 *
 * @param {Object} data - An object representing the accordion item.
 * @param {string} data.title - The title of the accordion item.
 * @param {Array} data.description 
 * - The description/content of the accordion item.
 * - Can contain strings for paragraphs or objects with type 'list'.
 *
 * @returns {JSX.Element} A React component that renders an accordion item.
 */
const AccordionComponent = ({ title, description }) => {

  return (
    <Accordion className="accordion-section">
      <Card style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}>
        <Card.Header className="accordion-header">
          <Accordion.Header className="w-100">
            <div>{title}</div>
          </Accordion.Header>
        </Card.Header>
        <Accordion.Body>
          {description?.map((item, index) => {
            // Render paragraphs
            if (typeof item === "string") {
              return <p key={index}>{item}</p>;
            }
            // Render lists
            else if (item.type === "list") {
              return (
                <ul key={index}>
                  {item.items.map((listItem, listIndex) => (
                    <li key={listIndex}>{listItem}</li>
                  ))}
                </ul>
              );
            }
            return null;
          })}
        </Accordion.Body>
      </Card>
    </Accordion>
  );
};

export default AccordionComponent;
